import { createTheme } from "@mui/material/styles";

/**
 * Quiz-scoped MUI theme for the redesigned quiz (screens 1–12).
 *
 * Kept separate from the shared app theme in `src/index.tsx` so the AccountApp
 * (which still uses Prompt) is unaffected. Palette `main` values must be literal
 * hex for MUI's contrast/shade computation — the brand colours mirror the
 * `--pop-*` variables in `snippets/pop-components.liquid`.
 */
export const quizTheme = createTheme({
  palette: {
    primary: { main: "#4a3026" }, // pop brown
    secondary: { main: "#8ee5ff" }, // pop blue
    success: { main: "#cced85" }, // pop green
    background: { default: "#faf5eb" }, // pop cream
    text: { primary: "#332115", secondary: "#3e3e3e" },
  },
  typography: {
    fontFamily: "'Archivo', 'Prompt', sans-serif",
  },
});
